export const NumberWithCommmas2 =(x) => {
    
    const numberFormatter = Intl.NumberFormat('en-US');
    const formatted = numberFormatter.format(x)
    
 return formatted
}